import React, { useEffect, useState } from "react";
import {
  getAllNotificationTypeWise,
  getNotificationSetting,
  saveNotificationSettings,
  updateNotificationAction
} from "../../redux/services/notification.service";
import { toast } from "react-toastify";
import { NotificationType } from "../../constants/NotificationType";
import { customStylesForGrid } from "../../constants/helper";
import CommonDataTable from "../../components/common/CommonDataTable";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { NotificationAction } from "../../constants/NotificationAction ";
import { FaEye, FaTrash } from "react-icons/fa";
import { confirmAction } from "../../components/common/commonAlert";

export default function NotificationListModal({
  show,
  onHide,
  notificationType,
  setRefreshNotification
}) {
  if (!show) return null;
  const navigate = useNavigate();
  const [tableState, setTableState] = useState({
    pageNo: 0,
    pageSize: 10,
    recordData: [],
    headerName: "",
    recordTotal: 0,
    sortDirection: "asc"
  });

  const [notifiationTypeReqModel, setNotificationTypeReqModel] = useState({
    WebuserId: 0,
    SearchText: "",
    NotificationTypeId: notificationType,
    FilterBy: 1,
    SortCol: "NotificationId",
    SortDir: "desc",
    PageNo: 0,
    PageSize: 10,
    RefreshTrigger: 0
  });

  const handleNotificationClick = (url) => {
    if (url) {
      navigate(url);
    }
  };
  const handleRead = async (notificationId) => {
    const payload = {
      notificationId,
      action: NotificationAction.Read
    };
    const response = await updateNotificationAction(payload);
    if (response.statusCode === 200) {
      setRefreshNotification(true);
      setTableState((prev) => ({
        ...prev,
        recordData: prev.recordData.map((item) =>
          item.notificationId === notificationId ? { ...item, isRead: true } : item
        )
      }));
    }
  };
  const showConfirmation = (notificationId) => {
    confirmAction(
      `Are you sure you want to delete this notification?`,
      () => handleDelete(notificationId),
      "Yes",
      "question"
    );
  };

  const handleDelete = async (notificationId) => {
    const payload = {
      notificationId,
      action: NotificationAction.Delete
    };
    const response = await updateNotificationAction(payload);
    if (response.statusCode === 200) {
      setNotificationTypeReqModel((prev) => ({
        ...prev,
        RefreshTrigger: prev.RefreshTrigger + 1
      }));
      setRefreshNotification(true);
    }
  };

  const columns = [
    {
      name: "Notification",
      grow: 1,
      cell: (row) => (
        <div
          className={row.isRead ? "w-100 py-2 " : "notification-unread w-100 py-2 "}
          onClick={() => handleNotificationClick(row.notificationURL)}
          style={{
            cursor: "pointer",
            fontWeight: 300
          }}>
          <div dangerouslySetInnerHTML={{ __html: row.notificationText }} />

          <div className="d-flex justify-content-between align-items-center mt-1">
            <small className="text-muted">
              <i className="bi bi-clock me-1"></i>
              {moment(row.notificationDate).format("DD/MM/YYYY hh:mm A")}
            </small>

            <div>
              {!row.isRead && (
                <button
                  className="btn btn-link p-0 me-2"
                  title="Read"
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent opening notification
                    handleRead(row.notificationId);
                  }}>
                  <FaEye />
                </button>
              )}
              <button
                className="btn btn-link p-0 text-danger"
                title="Delete"
                onClick={(e) => {
                  e.stopPropagation();
                  showConfirmation(row.notificationId);
                }}>
                <FaTrash />
              </button>
            </div>
          </div>
        </div>
      )
    }
  ];
  const handlePageNo = (page) => {
    setTableState((prev) => ({ ...prev, pageNo: page }));
    webUserFilters("PageNo", page);
  };

  const handlePageSizeChange = (perPage) => {
    setTableState((prev) => ({ ...prev, pageSize: perPage }));
    webUserFilters("PageSize", perPage);
  };

  const handleSort = (columnName) => {
    setTableState((prev) => {
      const newDir = prev.sortDirection === "asc" ? "desc" : "asc";
      setNotificationTypeReqModel({ ...notifiationTypeReqModel, SortDir: newDir });
      webUserFilters("SortCol", columnName);
      return { ...prev, sortDirection: newDir };
    });
  };

  const webUserFilters = (key, value) => {
    setNotificationTypeReqModel((ev) => ({
      ...ev,
      [key]: value
    }));
  };

  const handelViewAll = async (notificationTypeId) => {
    const qry = `?searchText=${encodeURIComponent(notifiationTypeReqModel?.SearchText || "")}&notificationTypeId=${notifiationTypeReqModel?.NotificationTypeId ?? ""}&filterBy=${notifiationTypeReqModel?.FilterBy}&sortCol=${notifiationTypeReqModel?.SortCol || ""}&sortDir=${notifiationTypeReqModel?.SortDir || ""}&startRow=${notifiationTypeReqModel?.PageNo}&pageSize=${notifiationTypeReqModel?.PageSize}`;
    const response = await getAllNotificationTypeWise(qry);
    if (response.statusCode === 200) {
      setTableState((prev) => ({
        ...prev,
        recordTotal: response.data.recordsTotal,
        recordData: response.data.data
      }));
    }
  };
  useEffect(() => {
    handelViewAll(notifiationTypeReqModel?.NotificationTypeId);
  }, [notifiationTypeReqModel]);

  return (
    <div className="container py-4">
      <div className="modal fade show d-block" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-xl modal-dialog-centered p-5">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title fw-bold">
                {notificationType == NotificationType.ActionRequired
                  ? "Actions Required"
                  : "General"}
              </h5>

              <button type="button" className="btn-close" onClick={onHide}></button>
            </div>

            <div className="modal-body">
              <div className="container p-0 m-0 row mw-100">
                <CommonDataTable
                  columns={columns}
                  data={tableState.recordData}
                  customStyles={customStylesForGrid}
                  pageNo={tableState.pageNo}
                  pageSize={tableState.pageSize}
                  recordTotal={tableState.recordTotal}
                  handlePageNo={handlePageNo}
                  handlePageSizeChange={handlePageSizeChange}
                  handleSort={handleSort}
                  enablePagination={true}
                />
              </div>
            </div>

            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={onHide}>
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
